/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from "react";
import { Link } from 'react-router-dom';
import NotFound from '../components/NotFound';

class TicketNotFound extends React.Component {
    
    render() {
        return (
            <NotFound>
                <h1 className="text-primary font-weight-normal">Query not found</h1>
                <p className="mb-0 text-dark">Looks like the query does not exist or you do not have access.</p>
                <p className="mb-0 text-dark">Please recheck the query ID and your account.</p>
                <p className="mb-0 text-dark">You can also check the list of your queries <Link to={'/helpme/list'}>here.</Link></p>
            </NotFound>
        )
    }
}

export default TicketNotFound;